// extracted by mini-css-extract-plugin
export default {"app":"_1CPxc","postPageApp":"_2QGTK","scrollable":"_3XnvP","backgroundOverlay":"_2-1ZL"};